import CloseConfirmModal from "PFApp/components/activity_actions/modals/close_confirm_modal";
import DropdownButton from "PFComponents/dropdown/dropdown_button";
import { useErrorsGrowl } from "PFCore/hooks/use_errors_growl";
import { forceManual } from "PFCore/services/activities";
import DotsIcon from "PFIcons/vertical_dots.svg";
import PropTypes from "prop-types";
import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import css from "./roles_actions.module.scss";

const RolesActions = ({ role, reload }) => {
  const { t } = useTranslation("auditPlanner");
  const growlError = useErrorsGrowl();
  const history = useHistory();
  const { state, coowned, id, workflow_state: workflowState } = role;
  const [showCloseConfirm, setShowCloseConfirm] = useState(false);
  const options = useMemo(() => {
    const result = [
      {
        id: "close",
        displayElement: <span className={css.dangerButton}>{t("close")}</span>,
        item: () => setShowCloseConfirm(true)
      }
    ];
    if (["pending", "auto_shortlisting"].includes(workflowState)) {
      result.unshift({
        id: "force_manual",
        displayElement: <span>{t("parts.forceManual")}</span>,
        item: () =>
          forceManual(role.id)
            .then(() => {
              history.push(`/audit_planner/manual_interventions/${role.parent_activity_id}/${role.id}`);
            })
            .catch(({ response }) => {
              growlError(response);
              reload();
            })
      });
    }
    return result;
  }, [t, role.id, workflowState]);

  const isDisabled =
    state === "complete" || workflowState === "exception" || (!coowned && ![null, "review"].includes(state));

  return (
    <>
      <DropdownButton
        style={{ marginLeft: "auto" }}
        options={options}
        buttonKind="blank"
        buttonStyle={{ height: 18 }}
        dropDownClassName={css.dropdown}
        dropDownStyle={{ maxHeight: 230 }}
        handleClick={(event) => event.preventDefault()}
        handleChange={(optionItem) => (optionItem.func ? optionItem.func() : optionItem())}
        qaId={`AuditControlCenterMoreButton.${id}`}
        disabled={isDisabled}
      >
        <DotsIcon width={20} height={17} />
      </DropdownButton>

      {showCloseConfirm && (
        <CloseConfirmModal
          activity={role}
          handleClose={() => setShowCloseConfirm(false)}
          type="audit_role"
          handleSuccess={reload}
        />
      )}
    </>
  );
};

RolesActions.propTypes = {
  role: PropTypes.shape({
    coowned: PropTypes.bool,
    state: PropTypes.string,
    workflow_state: PropTypes.string,
    parent_activity_id: PropTypes.number,
    id: PropTypes.number
  }),
  reload: PropTypes.func
};

export default RolesActions;
